import Portal from "../business/portal";
import UserPage from "../business/userPage/userPage";

const UserProfilePage = (props) => {
  return <Portal TabComponent={UserPage} props={props} />;
};
export default UserProfilePage;
